import { useEffect, useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ESpinner from 'components/others/Spinner';
import TitleCounter from 'components/others/TitleCounter';
import ListToolBarActions from 'components/toolbar/ListToolBarActions';
import SolarIcon from 'components/icons/SolarIcon';
import { useProcessRuns } from './model/useProcessRuns';
import ProcessRunsTable from './ProcessRunsTable';
import OffProcessRun from './OffProcessRun';
import NewProcessTemplatePicker from './NewProcessTemplatePicker';

const ProcessRuns = () => {
    const { t } = useTranslation(['Tasks']);
    const [params, setParams] = useSearchParams();
    const { processes, showSpinner, reload, triggerListReset, triggerListRefresh } = useProcessRuns();
    const [editorId, setEditorId] = useState<number | null>(null);
    const [editorOpen, setEditorOpen] = useState(false);
    const [pickerOpen, setPickerOpen] = useState(false);

    useEffect(() => {
        const open = Number(params.get('open') || 0);
        if (!open) return;
        setEditorId(open);
        setEditorOpen(true);
        const next = new URLSearchParams(params);
        next.delete('open');
        setParams(next, { replace: true });
    }, [params, setParams]);

    const openCreated = (processId: number) => {
        setPickerOpen(false);
        setEditorId(processId);
        setEditorOpen(true);
        reload();
    };

    return (
        <>
            <Row className="task-board-page position-relative">
                <Col className="col-sticky" sm={12}>
                    <div className="w-100 d-sm-flex pt-1 justify-content-between align-items-start">
                        <div>
                            <h4 className="p-0 m-0 mb-0 me-2 text-break">{t('processRuns.title')}</h4>
                            <TitleCounter />
                        </div>
                        <div className="mt-2 mt-sm-0">
                            <div className="mb-3 page-toolbar-actions">
                                <Button size="sm" variant="success" className="fs-14 text-nowrap" onClick={() => setPickerOpen(true)}>
                                    <SolarIcon name="plus" className="fs-14 p-0" />
                                    <span className="d-none d-md-inline ms-1">{t('processRuns.btnNew')}</span>
                                </Button>
                                <ListToolBarActions onReset={triggerListReset} onRefresh={triggerListRefresh} />
                            </div>
                        </div>
                    </div>
                </Col>
                <Col sm={12}>
                    {processes == null ? (
                        <ESpinner />
                    ) : (
                        <ProcessRunsTable
                            processes={processes}
                            showSpinner={showSpinner}
                            onEdit={(process) => {
                                setEditorId(process.ID);
                                setEditorOpen(true);
                            }}
                            onDeleted={reload}
                            onLaunched={reload}
                        />
                    )}
                </Col>
            </Row>

            <OffProcessRun 
                show={editorOpen}
                processId={editorId}
                onHide={() => setEditorOpen(false)}
                onSaved={reload}
            />

            <NewProcessTemplatePicker
                show={pickerOpen}
                onHide={() => setPickerOpen(false)}
                onCreated={openCreated}
            />
        </>
    );
};

export default ProcessRuns;
